<button #metadataBtn class="btn btn-sm btn-outline-secondary me-1 mb-1" (click)="openMetaData(metaData, indicator)">
  Metadata
  <i *ngIf="indicatorNotificationCount" class="fas fa-exclamation-triangle" [ngStyle]="{'color': warningIconColor}"></i>
</button>
<!-- MetaData modal -->
<ng-template #metaData let-modal>
  <div class="modal-body" style="height: 90vh; overflow-y: auto;">
    <button type="button" class="btn-close float-end" aria-label="Close" (click)="modal.close(); onClose()"></button>
    <h3 class="modal-title" ngbAutofocus>Metadata</h3>
    <div *ngIf="notifications && notifications.length" >
      <div *ngFor="let notification of notifications; trackBy: trackByIndex" 
            class="rounded d-flex align-items-center py-3 px-3 my-3"
            [ngClass]="{
              'alert-danger': notification.NotificationTypeName === 'Red',
              'alert-primary': notification.NotificationTypeName === 'Blue'
            }"
        >
        <div>
          <i class="fas fa-exclamation-triangle me-3"></i>
        </div>
        <div [innerHTML]="notification.NotificationDescription"></div>
      </div>
    </div>
    <div class="my-2">
      <div *ngIf="isMetadataAvailable" class="btn btn-sm btn-primary" (click)="downloadDataCollection()">
        <span><i class="far fa-file-excel me-2"></i>Download Metadata (.xlsx)</span>
      </div>
      <button *ngIf="isMetadataAvailable" class="btn btn-sm btn-primary my-2 d-print-none ms-3" (click)="printDiv()">
        <i class="fas fa-solid fa-print me-1"></i> Print Metadata
      </button>   
      <div *ngIf="objectKeys(indicatorAgeMetaData).length > 0" style="float: right;">
        <button class="btn btn-sm btn-secondary me-2"  [ngClass]="{'active' : displayTable == indicatorMetaData}" (click)="changeTable('regular')">Regular</button>
        <button class="btn btn-sm btn-secondary" [ngClass]="{'active' : displayTable == indicatorAgeMetaData}" (click)="changeTable('age')">Age Standardised</button>
      </div>
      <hr />
      <div id="metadataContent" class="mt-4">
        <div *ngFor="let category of displayTable | groupBy: 'CategoryName' | pairs; trackBy: trackByIndex" class="mb-5">
          <h5 class="mb-3">{{ category[0] }}</h5>
          <table class="table table-bordered">
            <tbody>
              <tr *ngFor="let data of category[1]; trackBy: trackByIndex">
                <td class="col-4 bg-light">{{ data.MetaDataTitle }}</td>
                <td class="col-8">{{ data.MetaData }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="!isMetadataAvailable" class="my-5 px-1">
        <p>There is not metadata available for this indicator...</p>
      </div>
    </div>
  </div>
</ng-template>